
import { defineComponent, onMounted, reactive } from 'vue'

// @components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'
import NewPagination from '@/common/new-components/NewPagination/index.vue'
import NewTable from '@/common/new-components/NewTable/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

import LoadStandardsFilters from '@/modules/TMSModule/components/LoadStandardsFilters/index.vue'
import LoadStandardExcel from '@/modules/TMSModule/components/LoadStandardExcel/index.vue'
import LoadStandardsActions from '@/modules/TMSModule/components/LoadStandardsActions/index.vue'

// @types
import { LoadStandard, GetLoadStandardsParams } from '@/new-services/types/tms'

// @new-services
import tmsAPI from '@/new-services/tms.service'

// @composable
import useActions from '@/common/composable/useActions'

const TABLE_COLUMNS = [
    {
        key: 'direction',
        name: 'Направление',
    },
    {
        key: 'capacityData',
        name: '20 - тонник',
        value: 6,
    },
    {
        key: 'capacityData',
        name: '10 - тонник',
        value: 5,
    },
    {
        key: 'capacityData',
        name: '5 - тонник',
        value: 3,
    },
    {
        key: 'capacityData',
        name: '3 - тонник',
        value: 2,
    },
    {
        key: 'capacityData',
        name: 'Газель',
        value: 1,
    },
    {
        key: 'actions',
        name: '',
    },
]

export default defineComponent({
    components: {
        PageTitle,
        NewButton,
        LoadStandardsFilters,
        LoadStandardsActions,
        NewLimit,
        NewPagination,
        NewTable,
        Loader,
        LoadStandardExcel,
    },
    setup() {
        const { actions_state, startCreate, startUpdate, closeActions } = useActions<LoadStandard>()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            is_excel: false,
            list: [] as LoadStandard[],
            filters: {
                limit: 50,
                current_page: 1,
                total_pages: 1,
                total_items: 1,
                //
                fromCityId: null as number | null,
                toCityId: null as number | null,
                transitCityIds: [] as number[],
            },
        })

        const loadLoadStandards = async () => {
            try {
                state.is_loading = true

                const params: GetLoadStandardsParams = {
                    page: state.filters.current_page,
                    limit: state.filters.limit,
                    //
                    fromCityId: state.filters.fromCityId,
                    toCityId: state.filters.toCityId,
                    transitCityIds: state.filters.transitCityIds,
                }

                const response = await tmsAPI.getLoadStandards(params)
                state.list = response.data.data

                if (response.data.meta) {
                    state.filters.total_items = response.data.meta.total
                    state.filters.total_pages = response.data.meta.last_page
                }

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const onFiltersChanged = (filters: GetLoadStandardsParams) => {
            state.filters.fromCityId = filters.fromCityId as number | null
            state.filters.toCityId = filters.toCityId as number | null
            state.filters.transitCityIds = filters.transitCityIds as number[]

            state.filters.current_page = 1

            loadLoadStandards()
        }

        const onFiltersReset = () => {
            state.filters.fromCityId = null
            state.filters.toCityId = null
            state.filters.transitCityIds = []

            state.filters.current_page = 1

            loadLoadStandards()
        }

        const onLimitChange = (new_limit: number) => {
            state.filters.limit = new_limit
            loadLoadStandards()
        }

        const onChangePage = (new_page: number) => {
            state.filters.current_page = new_page
            loadLoadStandards()
        }

        onMounted(loadLoadStandards)

        const formatValue = (value: string | number | null | undefined, type: string) => {
            if (value) {
                if (type === 'w') return `${value.toLocaleString('ru-RU')} кг`
                return `${value.toLocaleString('ru-RU')} м3`
            }

            return '-'
        }

        const onLoadStandardsCreated = () => {
            closeActions()
            loadLoadStandards()
        }

        const openExcel = () => {
            state.is_excel = true
        }

        const closeExcel = () => {
            state.is_excel = false
        }

        const onConfirmExcel = () => {
            closeExcel()
            loadLoadStandards()
        }

        const getCapacity = (
            id: number,
            capacities: { id: number; cubatureLoadStandard: number; weightLoadStandard: number }[]
        ) => {
            return capacities.find((capacity) => capacity.id === id)
        }

        return {
            actions_state,
            startCreate,
            startUpdate,
            closeActions,
            TABLE_COLUMNS,
            state,
            onFiltersChanged,
            onFiltersReset,
            onLimitChange,
            onChangePage,
            loadLoadStandards,
            formatValue,
            onLoadStandardsCreated,
            openExcel,
            closeExcel,
            onConfirmExcel,
            getCapacity,
        }
    },
})
